/**
 * Files in these modules are observers to state changes happening
 * in stores and trigger mutation, side effects by making API calls
 * and mutating stores as a result.
 */
import { init as stripeInit } from './stripe';

export function init() {
  stripeInit();
}
